import PromiseQueue from "@utils/promise.queue";
const commentPromiseQueue = new PromiseQueue();
commentPromiseQueue.start();
export default commentPromiseQueue;
